import { html as e, ref as i, slotted as l } from "@microsoft/fast-element";
import { textFieldTemplate as o } from "@matrix42/fast-foundation";
const p = e`
  ${o()}
  <div
    class="hint"
    part="hint"
    style="${(t) => t.slottedHints && t.slottedHints.length > 0 ? "" : "display: none"}"
  >
    <slot
      name="hint"
      ${i("hint")}
      ${l({
  property: "slottedHints"
})}
    ></slot>
  </div>
`;
export {
  p as inputTemplate
};
